// eslint-disable-next-line import/prefer-default-export
export const SEND_BROKER_EMAIL = 'inspectionForm/SEND_BROKER_EMAIL';
